import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const CabañaMar = () => {
  return (
    <div className="container mt-5">
      {/* Bootstrap Carousel */}
      <div id="granjaCarousel" className="carousel slide mb-5" data-bs-ride="carousel">
        <div className="carousel-indicators">
          <button type="button" data-bs-target="#granjaCarousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
          <button type="button" data-bs-target="#granjaCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
          <button type="button" data-bs-target="#granjaCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
          <button type="button" data-bs-target="#granjaCarousel" data-bs-slide-to="3" aria-label="Slide 4"></button>
          <button type="button" data-bs-target="#granjaCarousel" data-bs-slide-to="4" aria-label="Slide 5"></button>
          <button type="button" data-bs-target="#granjaCarousel" data-bs-slide-to="5" aria-label="Slide 6"></button>
          <button type="button" data-bs-target="#granjaCarousel" data-bs-slide-to="6" aria-label="Slide 7"></button>
          <button type="button" data-bs-target="#granjaCarousel" data-bs-slide-to="7" aria-label="Slide 8"></button>
          <button type="button" data-bs-target="#granjaCarousel" data-bs-slide-to="8" aria-label="Slide 9"></button>
          <button type="button" data-bs-target="#granjaCarousel" data-bs-slide-to="9" aria-label="Slide 10"></button>
        </div>
        <div className="carousel-inner rounded shadow">
        <div className="carousel-item active">
            <img src="/mar4.JPG" className="d-block w-100" alt="Campo abierto" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
          </div>
          <div className="carousel-item">
            <img src="/mar.jpg" className="d-block w-100" alt="Granja" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
          </div>
          <div className="carousel-item">
            <img src="/mar2.jpg" className="d-block w-100" alt="Animales" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
          </div>
          <div className="carousel-item">
            <img src="/mar3.jpg" className="d-block w-100" alt="Campo abierto" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
          </div>
          <div className="carousel-item">
            <img src="/mar5.JPG" className="d-block w-100" alt="Campo abierto" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
          </div>
          <div className="carousel-item">
            <img src="/mar6.JPG" className="d-block w-100" alt="Campo abierto" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
          </div>
          <div className="carousel-item">
            <img src="/mar7.JPG" className="d-block w-100" alt="Campo abierto" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
          </div>
          <div className="carousel-item">
            <img src="/mar8.jpg" className="d-block w-100" alt="Campo abierto" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
          </div>
          <div className="carousel-item">
            <img src="/mar9.jpg" className="d-block w-100" alt="Campo abierto" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
          </div>
          <div className="carousel-item">
            <img src="/mar10.jpg" className="d-block w-100" alt="Campo abierto" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
          </div>
        </div>
        <button className="carousel-control-prev" type="button" data-bs-target="#granjaCarousel" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#granjaCarousel" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>

      <div className="card text-center shadow-lg">
        <div className="card-body">
          <h1 className="card-title text-uppercase fw-bold text-success">CABAÑA VISTA AL MAR</h1>
          <h3 className="mt-4">Detalles de la Cabaña:</h3>
          <ul className="list-group list-group-flush">
            <li className="list-group-item">Cama Extra Doble</li>
            <li className="list-group-item">Cama Sencilla</li>
            <li className="list-group-item">Armario</li>
            <li className="list-group-item">Escritorio</li>
            <li className="list-group-item">⁠Mini Bar</li>
            <li className="list-group-item">⁠Baño con ducha al aire libre</li>
            <li className="list-group-item">Balcón</li>
            <li className="list-group-item">35Mts²</li>
            <li className="list-group-item">⁠Capacidad para 3 personas</li>
          </ul>
          <h4 className="mt-4">Check-in & Check-out:</h4>
          <p className="fs-5">Check-in: 03:00 PM (Early check-in sujeto a disponibilidad)</p>
          <p className="fs-5">Check-out: 12:00 PM (Express check-out sujeto a disponibilidad)</p>
          <h4 className="mt-4">Instrucciones Especiales:</h4>
          <p className="fs-5">No se aceptan parlantes, es un espacio para descansar.</p>
          <p className="fs-5">Precio por descorche por botella: $80.000</p>
          <p className="fs-5">No se permite fumar dentro de la cabaña.</p>
          <h4 className="mt-4">Mascotas:</h4>
          <p className="fs-5">No se aceptan mascotas.</p>
          <h4 className="mt-4">Energía:</h4>
          <p className="fs-5">Todo nuestro sistema es con luz solar.</p>
        </div>
      </div>
    </div>
  );
};

export default CabañaMar;
